<h3 class="top-padding"> {{ course['name'] }} </h3>
<div style="text-align: left;">
  <a routerLink="../">返回</a>
</div>
<hr>

<div class="container">
  &nbsp;
  <iframe class="frame" [src]="url"></iframe>
</div>
